import * as actions from '../actions'

var defaultState = null;

export default function messageUsers(state = defaultState, action) {
    switch (action.type) {

        case actions.MESSAGE_USER_GET:
            var newState = state;
            if (!action.error) {
                newState = action.payload.data;
            }
            return newState;

        case actions.MESSAGE_USER_CLEAN:
            return defaultState;

        default:
            return state;

    }
}
